import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TriangleDownIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='triangle-down'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M10 12.5L5 7.5H15L10 12.5Z'
				fill={props?.color || '#2E2E6B'}
			/>
		</svg>
	);
};

export default TriangleDownIcon;
